import { createSlice } from '@reduxjs/toolkit';
import { signInWithPassword, getUserNameWithSessionKey } from './SignInApi';

import type { PayloadAction } from '@reduxjs/toolkit';

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- grandfathered in when correcting rule regression after upgrade to v6.x
interface SignInState {
    userEmailAddress: string;
    authenticatingUser: boolean;
}

const initialState: SignInState = {
    userEmailAddress: '',
    authenticatingUser: false
};

const signInSlice = createSlice({
    name: 'signIn',
    initialState,
    reducers: {
        authenticationFailed: (state) => {
            state.authenticatingUser = false;
        },
        usernameChanged: (state, action: PayloadAction<string>) => {
            state.userEmailAddress = action.payload;
        }
    },
    extraReducers: (builder) => {
        // These signatures are reducer callbacks and there are no overloads with single parameter.
        builder.addCase(signInWithPassword.pending, (state, _) => { // eslint-disable-line @typescript-eslint/no-unused-expressions -- eslint update introduced errors
            state.authenticatingUser = true;
        }),
        builder.addCase(signInWithPassword.fulfilled, (state, action) => {
            const returnUrl = action.payload.data;
            window.location.replace(returnUrl === undefined ? '/Online/' : returnUrl);
        }),
        builder.addCase(signInWithPassword.rejected, (state, action) => {
            throw action.payload;
        }),
        builder.addCase(getUserNameWithSessionKey.fulfilled, (state, action) => {
            state.userEmailAddress = action.payload.data;
        });
    }
});

const { actions, reducer } = signInSlice;

export const {
    authenticationFailed,
    usernameChanged
} = actions;

export default reducer;
